var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoWlfi = function SvgLogoWlfi(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 80,
    fill: "none",
    viewBox: "0 0 288 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-wlfi_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo-wlfi_svg__b",
    width: 178,
    height: 33,
    x: 55,
    y: 23,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.018 24H55v32h177.018z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-wlfi_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo-wlfi_svg__c",
    width: 98,
    height: 33,
    x: 55,
    y: 23,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152.945 24H55v32h97.945z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EAAC08",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#logo-wlfi_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.94 36.963c.268.046.451.33.413.635-.041.305-.289.515-.557.47l-14.183-2.491c1.522 2.112 3.847 3.854 6.215 4.438l16.443 3.198-20.784 12.012c2.532 1.19 5.396.96 7.747-.6l.432-.304 7.662-5.43c.212-.15.494-.076.626.165.133.244.068.56-.144.714l-7.952 5.635c2.192 1.033 4.685.698 6.597-.855l6.054-5.319c.197-.175.484-.132.636.094a.57.57 0 0 1-.082.726l-6.179 5.427c2.151.27 4.989-.413 6.757-1.895 2.045-1.864 4.598-4.58 6.833-5.819 1.385-.766 2.928-1.158 4.856-.876 1.316.518 2.701.764 4.091.723.915.178 1.717.785 2.216 1.663.289-1.412-.246-3.05-1.465-3.468.017-.513-.2-.987-.558-1.267l-.331-.185-8.812-4.932-12.408-6.948a28.4 28.4 0 0 0-5.786-2.303c-1.204-.33-2.264-.508-3.49-.73L55 23.998c1.636 2.379 3.796 3.686 6.371 4.15l21.027 3.803c.268.048.448.333.405.637-.043.305-.291.51-.559.462l-16.691-3.018c1.233 1.871 3.042 3.133 5.058 3.536l.32.056zM143.124 30l-16.896 3.123c-.26.045-.504-.16-.543-.465-.041-.305.138-.59.398-.635l21.608-3.993c2.127-.49 4.015-1.931 5.253-4.03l-30.881 5.887h-.003c-2.476.471-4.128 1.127-6.378 2.373l-10.069 5.577 8.355 4.628c4.721-.972 9.057-1.645 13.78-2.617 2.26-.538 4.245-2.122 5.492-4.404l-14.431 2.668c-.26.046-.503-.16-.541-.465-.041-.304.137-.588.397-.634l18.751-3.465c2.165-.465 4.163-1.7 5.714-3.544l-.005-.002z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFC",
    d: "M216.034 32.255v6.151h8.408v3.09h-8.408v9.36h-3.565v-21.69h12.418v3.09zM208.614 47.678v3.179h-12.628V29.166h3.566v18.512zM192.551 29.166l-5.11 21.69h-5.853l-3.779-15.767-3.441 15.768h-5.793L162.9 29.166h3.684l4.607 18.63h.889l3.685-17.769h4.13l4.198 17.77h.86l4.092-18.631zM228.514 50.856V29.165h3.505v21.691z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-wlfi_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 24h177.04v32H55z"
  })))));
};
export default SvgLogoWlfi;